import actions from './actions';

const initState = {
  errorMessage: null,
  isError: false,
  saveUploadedFileMetadataLoading: false,
  files: null,
  filesLoading: false,

  fileAccessURL: null,
  fileAccessURLLoading: false,
  fileAccessURLIsError: false
};

export default function filesReducer(state = initState, action) {
  switch (action.type) {
    case actions.SAVING_FILE_METADATA:
      return {
        ...state,
        saveUploadedFileMetadataLoading: action.loading,
        isError: false
      };

    case actions.SAVE_FILE_METADATA_SUCCESS:
      return {
        ...state,
        saveUploadedFileMetadataLoading: action.loading,
        errorMessage: action.message,
        isError: false
      };

    case actions.SAVE_FILE_METADATA_FAILED:
      return {
        ...state,
        saveUploadedFileMetadataLoading: action.loading,
        errorMessage: action.message,
        isError: true
      };

    case actions.FETCHING_FILES:
      return {
        ...state,
        filesLoading: true,
        isError: false
      };

    case actions.FETCH_FILES_SUCCESS:
      return {
        ...state,
        files: action?.result,
        filesLoading: false,
        errorMessage: action.message,
        isError: false
      };

    case actions.FETCH_FILES_FAILED:
      return {
        ...state,
        filesLoading: false,
        errorMessage: action.message,
        isError: true
      };

    case actions.FETCHING_FILE_ACCESS_URL:
      return {
        ...state,
        fileAccessURLLoading: true,
        fileAccessURL: null
      };

    case actions.FETCH_FILE_ACCESS_URL_SUCCESS:
      return {
        ...state,
        fileAccessURLLoading: false,
        fileAccessURLIsError: false,
        fileAccessURL: action.result
      };

    case actions.FETCH_FILE_ACCESS_URL_FAILED:
      return {
        ...state,
        fileAccessURLLoading: false,
        fileAccessURLIsError: true
      };
    default:
      return state;
  }
}
